import {MessageType} from "../../services/messageProvider";
import {startContainerChange} from "../../utils/util";

export function Resize() {
	return (
		<div id="resize" style={{width: "20px", height: "20px", overflow: "hidden", bottom: "0px", right: "0px", cursor: "nw-resize"}} className="position-absolute"
			onMouseDown={(mouseEvent: MouseEvent) => startContainerChange(mouseEvent, MessageType.resize)}>
			<div style={{width: "70px", height: "60px", transform: "rotate(-45deg)"}}>
				<hr class="m-0 mb-1 border-dark"/>
				<hr class="m-0 mb-1 border-dark"/>
				<hr class="m-0 mb-1 border-dark"/>
			</div>
		</div>
	);
}
